import React, { useState, useEffect, useRef } from "react";
import {
	IonCol,
	IonGrid,
	IonImg,
	IonRow,
	IonText,
	IonModal,
	IonButton,
	IonLabel,
	IonContent,
	IonRefresher,
	IonRefresherContent,
	isPlatform,
} from "@ionic/react";
import { RefresherEventDetail } from "@ionic/core";
import "../../global.scss";
import CustomRoutes from "../../customRoutes";
import Dashboard from "./dashboard";
import ConfirmScreen from "./Confirmation/confirmation";
import Profile from "./profile";
import * as constants from "../../constants";
import Header from "../../utils/Header";
import { connect } from "react-redux";
import PersonalDetails from "../OnBoarding/PersonalDetails";
import MyAdd from "./myAddresses";
import AddNewAddress from "./addNewAddress";
import { AlertMessage } from "../../utils/alertMessage";
import AddVehicle from "../OnBoarding/AddVehicle";
import DocumentVault from "./DocumentVault/documentVault";
import AddDocuments from "./DocumentVault/addDocument";
import { COLLECTIONS, getDeviceToken, getSubCollectionData } from "../../firebase";
import firebase from "firebase";
import {
	signIn,
	deleteAddress,
	setDefAddress,
	storeCurrentLatLong,
	storeUserMapAddress,
	updateVehicleDefaultAddress,
	userDocuments,
	userVehicles,
	saveUserVehicles,
	saveCatelogVehicleId,
	saveServiceSearchData,
	// getVehiclePerspectives,
	getCartItemsList,
	getMultiServiceData,
	// getDates,
	getOffersData,
	getArticlesData,
	logout,
	saveServiceData,
	fetchBookings,
	// fetchReservations,
	getUserRefferalDetails,
	saveDeviceToken,
	// globalSettings,
	// getNotifications,
	getVehicleImage,
	getStoreAppVersions,
} from "../../Store/Actions";
import addInsurance from "./DocumentVault/addInsurance";
import AddPucc from "./DocumentVault/addPUCC";
import MyVehicles from "../OnBoarding/MyVehicles";
import ManageYourVehicle from "../OnBoarding/ManageYourVehicle";
import settings from "./settings/settings";
import HelpAndSupport from "./settings/helpAndSupport";
import BookService from "./BookService/bookService";
import ServiceDetails from "./BookService/serviceDetails";
import workshopQuality from "./Workshop/workshopQuality";
import Offers from "./Offers/Offers";
import OfferDetails from "./Offers/OfferDetails";
import ReferAndEarn from "./Offers/ReferAndEarn";
import Cart from "./Cart/cart";
import BodyPanel from "./BodyPanel/bodyPanel";
import BookingDetails from "./Booking/BookingDetails";
import MyBookings from "./Booking/MyBookings";
import { checkMediaQuery } from "../../utils";
import Notifications from "./Notifications/Notifications";
import SelectWorkShop from "./Workshop/selectWorkshop";
import WorkShopDetails from "./Workshop/workshopDetail";
// import { Device } from "@capacitor/core";
import { Device } from "@ionic-native/device";
// import { updateUser } from "../../intercom";

// import {
// 	Plugins,
// 	PushNotification,
// 	PushNotificationToken,
// 	PushNotificationActionPerformed,
// 	LocalNotification,
// 	LocalNotificationActionPerformed,
// 	Capacitor,
// } from "@capacitor/core";

import { AppVersion } from "@ionic-native/app-version";

// const { PushNotifications, LocalNotifications }: any = Plugins;

declare let window: any;

const Portal: React.FC = (props: any) => {
	const [showAppUpdateModal, setShowAppUpdateModal] = useState(false);
	const [storeName, setStoreName] = useState("");

	React.useEffect(() => {
		document.getElementById("panel_layout")?.scrollTo(0, 0);
		const paths = [
			"/portal/book_service",
			"/portal/service_details",
			"/portal/workshop-quality",
		];
		if (
			!paths.includes(props.history.location.pathname) &&
			(props.serviceSearch || props.serviceSearchTags.length)
		) {
			props.saveServiceSearchData({});
		}
	}, [props.history.location.pathname]);

	React.useEffect(() => {
		if (isPlatform("ios") || isPlatform("android")) {
			AppVersion.getVersionCode()
				.then((data: any) => {
					console.log("this App version === ", data);
					console.log("Store App version === ", props.StoreAppVersions.data[0]);

					if (isPlatform("android")) {
						if (data < props.StoreAppVersions.data[0].androidVersion) {
							setStoreName("Google Play Store");
							// console.log("New Update is available");
							setShowAppUpdateModal(true);
						}
					} else {
						if (data < props.StoreAppVersions.data[0].iosVersion) {
							setStoreName("Apple App Store");
							// console.log("New Update is available");
							setShowAppUpdateModal(true);
						}
					}
				})
				.catch((error: any) => {
					console.error("Error updating document 2: ", error);
				});
		}
	}, [props.StoreAppVersions]);

	const navigateToStore = () => {
		if (cordova.platformId === "android") {
			window.open(
				"https://play.google.com/store/apps/details?id=com.valueplus.software",
				"_blank"
			); //to open new page
		} else {
			window.open(
				"https://apps.apple.com/in/app/t-serv-total-car-service/id1619335263",
				"_blank"
			); //to open new page
		}
	};

	React.useEffect(() => {
		// if (props.settings.notificationsEnabled) {
		// 	addNotificationListeners();
		// } else {
		// 	removeNotificationListeners();
		// }
	}, [props.settings.notificationsEnabled]);

	const [customizeService, setCustomizeService] = React.useState<any>(false);

	React.useEffect(() => {
		document.getElementById("panel_layout")?.scrollTo(0, 0);
		// updateUser(props.email, props.uid, props.name); //! uncomment this line to update user details in intercom
		getDocumentsData();

		props.getCartItemsList();
		fetchOffersAndArticles();
		// props.globalSettings();
		// props.getNotifications();
		// props.getDates();

		// if (window.cordova) {
		// 	PushNotifications.requestPermission().then((permission: any) => {
		// 		if (permission.granted) {
		// 			PushNotifications.register();
		// 		}
		// 		getdeviceToken();
		// 	});
		// }

		// window.addEventListener("scroll", loadMore);
	}, []);

	// const loadMore = () => {
	//   if (
	//     window.innerHeight + document.documentElement.scrollTop ===
	//     document.scrollingElement.scrollHeight
	//   ) {
	//     // Do load more content here!
	//   }
	// };

	// React.useEffect(() => {
	//   (async function () {
	//     if (props.userVehiclesList.length && props.sliderCatelogVehicleId) {
	//       const registrationNumberList = props.userVehiclesList.filter(
	//         (ele: any) => ele.catalogVehicleId === props.sliderCatelogVehicleId,
	//       );

	//       await props.fetchReservations(registrationNumberList[0].registrationNumber);
	//     }
	//   })();
	// }, [props.userVehiclesList, props.sliderCatelogVehicleId]);

	async function getdeviceToken() {
		// PushNotifications.addListener("registration", (token: PushNotificationToken) => {
		// 	saveDeviceToken(token.value);
		// });
		// PushNotifications.addListener("registrationError", (error: any) => {});
		// addNotificationListeners();
		// OLDER Comment - Older than 15 Aug 22
		// PushNotifications.addListener(
		//   "pushNotificationReceived",
		//   async (notification: PushNotification) => {
		//     console.log("Push received: " + JSON.stringify(notification));
		//     doLocalNotif(notification);
		//     LocalNotifications.addListener(
		//       "localNotificationActionPerformed",
		//       (
		//         event: LocalNotificationActionPerformed,
		//         notification: PushNotification
		//       ) => {
		//         props.history.push("/portal/notifications");
		//         // actionOnNotification(notification);
		//         // this.router.navigateByUrl('messages');
		//       }
		//     );
		//   }
		// );
		// PushNotifications.addListener(
		//   "pushNotificationActionPerformed",
		//   async (notification: PushNotificationActionPerformed) => {
		//     console.log("Action performed: " + JSON.stringify(notification));
		//     actionOnNotification(notification);
		//   }
		// );
	}

	// const addNotificationListeners = () => {
	// 	PushNotifications.addListener(
	// 		"pushNotificationReceived",
	// 		async (notification: PushNotification) => {
	// 			doLocalNotif(notification);

	// 			LocalNotifications.addListener(
	// 				"localNotificationActionPerformed",
	// 				(event: LocalNotificationActionPerformed, notification: PushNotification) => {
	// 					props.history.push("/portal/notifications");
	// 					// actionOnNotification(notification);
	// 					// this.router.navigateByUrl('messages');
	// 				}
	// 			);
	// 		}
	// 	);

	// 	PushNotifications.addListener(
	// 		"pushNotificationActionPerformed",
	// 		async (notification: PushNotificationActionPerformed) => {
	// 			actionOnNotification(notification);
	// 		}
	// 	);
	// };

	// const removeNotificationListeners = () => {
	// 	PushNotifications.removeAllListeners();
	// };

	// const doLocalNotif = (notification: any) => {
	// 	LocalNotifications.schedule({
	// 		notifications: [
	// 			{
	// 				body: notification.body,
	// 				bookingId: notification.bookingId,
	// 				collapse_key: notification.collapse_key,
	// 				screenName: notification.screenName,
	// 				title: notification.title,
	// 				id: Date.now(),
	// 			},
	// 		],
	// 	}).catch((error: any) => console.error(error, "local notification error"));
	// };

	const actionOnNotification = (message: any) => {
		if (message.hasOwnProperty("notification")) {
			props.history.push({
				pathname: "/portal/booking_details",
				state: {
					idOfBooking: message.notification.data.bookingId,
				},
			});
		}
	};

	async function listenForTokenRefresh() {
		if (window.cordova) {
			window.cordova.plugins.firebase.messaging.onTokenRefresh(async function () {
				const device_token = await getDeviceToken();
				saveDeviceToken(device_token);
			});
		}
	}
	const saveDeviceToken = async (token: any) => {
		const deviceModel: any = await Device.model;
		const deviceId: any = await Device.uuid;
		props.saveDeviceToken({
			deviceId: deviceId,
			deviceName: deviceModel,
			token: token,
		});
	};

	const fetchOffersAndArticles = async () => {
		if (window.cordova) {
			props.getStoreAppVersions();
			console.log("AppVersion.getVersionCode() ==== ", AppVersion);
		}

		await Promise.all([
			props.getOffersData(),
			props.getArticlesData({
				articleListId: "default",
				clientName: constants.CLIENT_NAME,
			}),
			props.fetchBookings(),
			props.getUserRefferalDetails(),
		]);
	};

	const getMultiServices = async (arr: any) => {
		console.log("GMS = Make ==== 00", props);
		const vMake = props.userVehiclesList.find(
			(item: any) => item.catalogVehicleId === props.sliderCatelogVehicleId
		);

		if (!!vMake) {
			console.log("GMS = Make ==== 01", vMake);

			const MultiData = await props.getMultiServiceData({
				serviceIdList: arr,
				clientName: constants.CLIENT_NAME,
				make: vMake.make,
			});

			if (!!MultiData && MultiData.status === "SUCCESS") {
				const { data = [] } = MultiData;
				const res = data.map((t1: any) => ({
					addOnSections: t1.addOnSections,
					...t1.service,
					...props.cart_items.find((t2: any) => t2.serviceId === t1.service.serviceId),
				}));
				props.saveServiceData(res);
			}
		}
	};

	React.useEffect(() => {
		const arr = props.cart_items.map((ele: any) => ele.serviceId);
		if (arr.length > 0) {
			getMultiServices(arr);
		}
	}, [props.cart_items]);

	React.useEffect(() => {
		if (!!props.vehicleImages) {
			const vId = props.vehicleImages.catalogVehicleId;
			const imgUrl = props.vehicleImages.imageUrl;

			const img = props.userVehiclesList.map((ele: any) => {
				if (ele.catalogVehicleId === vId) {
					ele.imageUrl = imgUrl;
				}
			});
		}
	}, [props.vehicleImages]);

	React.useEffect(() => {
		if (!!props.service_data_value && !!props.cart_items && props.cart_items.length) {
			const res = props.service_data_value.map((t1: any) => ({
				addOnSections: t1.addOnSections,
				...t1.service,
				...props.cart_items.find((t2: any) => t2.serviceId === t1.service.serviceId),
			}));
			props.saveServiceData(res);
		}
	}, [props.service_data_value]);

	const getDocumentsData = async () => {
		const documents: any = await getSubCollectionData(
			props.uid,
			COLLECTIONS.USERS,
			COLLECTIONS.DOCUMENTS
		);
		const vechicles: any = await getSubCollectionData(
			props.uid,
			COLLECTIONS.USERS,
			COLLECTIONS.VECHICLES
		);
		await props.userDocuments(
			documents.data.map((ele: any) => {
				if (ele.hasOwnProperty("expirationDate")) {
					return {
						...ele,
						// expirationDate: new Date(
						//   ele.expirationDate.seconds * 1000
						// ).toUTCString(),
						expirationDate: new Date(ele.expirationDate).getTime(),
					};
				}
				return ele;
			})
		);

		// console.log("vechicles =======...", vechicles);

		await props.saveUserVehicles(
			vechicles.data.map((ele: any) => {
				props.getVehicleImage(ele.model, ele.catalogVehicleId);

				ele.documentIds =
					!!ele.documentIds && ele.documentIds.length
						? ele.documentIds.map((ele: any) => {
								return ele;
						  })
						: [];
				ele.selectedAddressRef =
					ele.hasOwnProperty("defaultAddressRef") && !!ele.defaultAddressRef
						? (ele.defaultAddressRef || "").split("/").pop()
						: "";
				return {
					...ele,
					defaultAddressRef:
						ele.hasOwnProperty("defaultAddressRef") && !!ele.defaultAddressRef
							? ele.defaultAddressRef
							: "",
				};
			})
		);

		if (vechicles.data.length) {
			const catalogVehicleId =
				!!props.selectedVehicleRef &&
				(
					vechicles.data.find(
						(ele: any) => ele.did === props.selectedVehicleRef.split("/").pop()
					) || {}
				).catalogVehicleId;
			await props.saveCatelogVehicleId(catalogVehicleId);
		}
	};
	const { path } = props.match;

	function doRefresh(event: CustomEvent<RefresherEventDetail>) {
		console.log("Begin async operation");

		setTimeout(() => {
			console.log("Refresh Async operation has ended");
			event.detail.complete();

			getDocumentsData();

			props.getCartItemsList();
			fetchOffersAndArticles();
			// props.globalSettings();
			// props.getNotifications();
			// props.getDates();

			// if (window.cordova) {
			// 	PushNotifications.requestPermission().then((permission: any) => {
			// 		if (permission.granted) {
			// 			PushNotifications.register();
			// 		}
			// 		getdeviceToken();
			// 	});
			// }

			console.log("Refresh Async operation has ended ....................");
		}, 2000);
	}

	return (
		<IonContent forceOverscroll={false}>
			<IonRefresher
				slot="fixed"
				onIonRefresh={doRefresh}
				pullFactor={0.5}
				pullMin={100}
				pullMax={200}
			>
				<IonRefresherContent></IonRefresherContent>
			</IonRefresher>

			<IonGrid className="pd_0">
				<Header {...props} />
				<IonRow className="panel_layout" id="panel_layout">
					<IonCol className="left_panel" size="12" size-sm size-md="3">
						<div className="ser_body_div">
							<div className="ser_fir_child">
								<div
									className="services"
									onClick={() => props.history.push("/portal/book_service")}
								>
									<IonImg className="carImg" src="/images/car.svg" alt="car" />
									<IonText className="booking_div">{constants.BOOK_A_SERVICE}</IonText>
								</div>
								<div
									className="services"
									onClick={() => props.history.push("/portal/my_bookings")}
								>
									<IonImg className="carImg" src="/images/calendar.svg" alt="calendar" />
									<IonText className="booking_div">{constants.MY_BOOKINGS}</IonText>
								</div>
								<div
									className="services"
									onClick={() => props.history.push("/portal/offers")}
								>
									<IonImg className="carImg" src="/images/offer.svg" alt="offer" />
									<IonText className="booking_div">{constants.REWARDS_OR_OFFERS}</IonText>
								</div>
								<div
									className="services"
									onClick={() => props.history.push("/portal/settings")}
								>
									<IonImg className="carImg" src="/images/about.svg" alt="about" />
									<IonText className="booking_div">{constants.SETTINGS}</IonText>
								</div>
							</div>
							{/* Download App from stores */}
							{/* <div className="ser_sec_child">
              <div className="ion-text-center social-icons">
                <div className="app_layout">
                  <IonImg
                    className="download_icon"
                    src="/images/download_app.svg"
                    alt="downloadIcon"
                  />
                </div>
                <div className="download_app">
                  <IonText>{constants.DOWNLOAD_OUR_APP}</IonText>
                </div>
                <div className="social_icons">
                  <IonImg
                    className="google_play"
                    src="/images/googlePlay.png"
                    alt="googlePlay"
                  />
                  <IonImg
                    className="app_store"
                    src="/images/appStore.png"
                    alt="appStore"
                  />
                </div>
                <div className="insttal_app">
                  <IonText>{constants.INSTALL_APP_AND_GET_DISCOUNT}</IonText>
                </div>
              </div>
            </div> */}
						</div>

						<AlertMessage
							showAlert={showAppUpdateModal}
							alertMessage={`Update your app with latest version available in ${storeName}`}
							onDidDismiss={() => {
								setShowAppUpdateModal(false);
							}}
							alertHeader={"App Update"}
							actionItemForAlert={async () => {
								navigateToStore();
							}}
							cssClass={"alert-message"}
						/>

						{/* <IonModal
            isOpen={showAppUpdateModal}
            backdropDismiss={false}
            cssClass="slot-modal-update"
          >
            <div>
              <div className="slot_header_update">
                <IonLabel className="slot_heading">App Update</IonLabel>
              </div>

              <IonLabel className="update_modal_text">
                {`Update your app with latest version available in ${storeName}`}
              </IonLabel>
            </div>
            <div className="picker-actions-div">
              <IonButton
                color="light"
                className="picker-action-buttons"
                onClick={() => {
                  setShowAppUpdateModal(false);
                }}
              >
                {constants.REMIND_LATER}
              </IonButton>
              <IonButton
                color="light"
                className="picker-action-buttons"
                onClick={() => navigateToStore()}
              >
                {constants.UPDATE_NOW}
              </IonButton>
            </div>
          </IonModal> */}
					</IonCol>
					<CustomRoutes
						routes={[
							{
								path: `${path}/dashboard`,
								component: Dashboard,
							},
							{
								path: `${path}/offers`,
								component: Offers,
							},
							{
								path: `${path}/offer-details`,
								component: OfferDetails,
							},
							{
								path: `${path}/refer-earn`,
								component: ReferAndEarn,
							},
							{
								path: `${path}/profile`,
								component: Profile,
							},
							{
								path: `${path}/edit-profile`,
								component: PersonalDetails,
							},
							{
								path: `${path}/my-addresses`,
								component: MyAdd,
							},
							{
								path: `${path}/add-new-address`,
								component: AddNewAddress,
							},
							{
								path: `${path}/edit-address/:id`,
								component: AddNewAddress,
							},
							{
								path: `${path}/add-vehicles`,
								component: AddVehicle,
							},
							{
								path: `${path}/document-vault`,
								component: DocumentVault,
							},
							{
								path: `${path}/add-RC`,
								component: AddDocuments,
							},
							{
								path: `${path}/add-insurance`,
								component: addInsurance,
							},
							{
								path: `${path}/add-PUCC`,
								component: AddPucc,
							},
							{
								path: `${path}/my-vehicles`,
								component: MyVehicles,
							},
							{
								path: `${path}/manage-your-vehicle/:id`,
								component: ManageYourVehicle,
							},
							{
								path: `${path}/upload-documents/:id`,
								component: DocumentVault,
							},
							{
								path: `${path}/settings`,
								component: settings,
							},
							{
								path: `${path}/help-and-support`,
								component: HelpAndSupport,
							},
							{
								path: `${path}/book_service`,
								component: BookService,
							},
							{
								path: `${path}/service_details`,
								component: ServiceDetails,
							},
							{
								path: `${path}/workshop-quality`,
								component: workshopQuality,
							},
							{
								path: `${path}/select-workshop`,
								component: SelectWorkShop,
							},
							{
								path: `${path}/workshop-detail/:id`,
								component: WorkShopDetails,
							},
							{
								path: `${path}/cart`,
								component: !checkMediaQuery() ? Dashboard : Cart,
							},
							{
								path: `${path}/body-panel`,
								component: BodyPanel,
							},
							{
								path: `${path}/confirm`,
								component: ConfirmScreen,
							},
							{
								path: `${path}/booking_details`,
								component: BookingDetails,
							},
							{
								path: `${path}/my_bookings`,
								component: MyBookings,
							},
							{
								path: `${path}/notifications`,
								component: Notifications,
							},
						]}
						exact={{
							path: `${path}`,
							route: `${path}/dashboard`,
						}}
						// role={role}
					/>
					<IonCol size="12" size-sm size-md="3" className="my_cart_div">
						<div className="body_scroll">
							<div
								className={
									props.cart_items.length
										? "cart_header cart_border_bottom"
										: "cart_header "
								}
							>
								<div className="card_left_panel">
									{/* <IonImg src="/images/back_arrow.svg" className="left_arrow" /> */}
									<IonText className="my_cart">{constants.MY_CART}</IonText>
								</div>
							</div>
							<Cart {...props} />
						</div>
					</IonCol>
				</IonRow>
			</IonGrid>
		</IonContent>
	);
};

export default connect(
	({ auth, userInfo, cart, notification, settings }: any) => {
		return {
			...auth,
			...userInfo,
			...cart,
			...notification,
			...settings,
		};
	},
	{
		userDocuments,
		userVehicles,
		saveUserVehicles,
		deleteAddress,
		updateVehicleDefaultAddress,
		setDefAddress,
		storeCurrentLatLong,
		storeUserMapAddress,
		saveCatelogVehicleId,
		saveServiceSearchData,
		// getVehiclePerspectives,
		getCartItemsList,
		getMultiServiceData,
		// getDates,
		getArticlesData,
		getOffersData,
		signIn,
		logout,
		saveServiceData,
		fetchBookings,
		// fetchReservations,
		getUserRefferalDetails,
		saveDeviceToken,
		// globalSettings,
		// getNotifications,
		getVehicleImage,
		getStoreAppVersions,
	}
)(Portal);
